import { TransportMode, ExceptionStatus, ProductDivision } from "../graphql/graphql";

export const modeOfTransportOptions = Object.values(TransportMode).map(mode => ({
  value: mode,
  label: mode
}));

export const productDivisionOptions = Object.values(ProductDivision).map(division => ({
  value: division,
  label: division
}));

export const statusOptions = Object.values(ExceptionStatus).map(status => ({
  value: status,
  label: status.replace(/_/g, " ")
}));

// Utility function to check if a value is a valid enum member
export function isEnumValue<T extends object>(enumObj: T, value: unknown): value is T[keyof T] {
  return Object.values(enumObj).includes(value as T[keyof T]);
}